"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCalculatorPnLValue = useCalculatorPnLValue;
var _react = require("react");
var _reactRedux = require("react-redux");
var _hooks = require("../../hooks");
var _decimalPlacesHelper = require("../../../../helpers/decimalPlaces/decimalPlacesHelper");
var _futuresInstrumentsSelector = require("../../../../redux/futures/selectors/futuresInstrumentsSelector");
var _actions = require("../../../../redux/futures/actions");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * @typedef {Object} FormValues
 * @prop {Long' | 'Short'} type
 * @prop {number} leverage
 * @prop {number} quantity
 * @prop {number} entryPrice
 * @prop {number} exitPrice
 *
 *
 * @typedef {Object} Instrument
 * @prop {number} InstrumentId
 * @prop {string} Symbol
 * @prop {number} Product1
 * @prop {string} Product1Symbol
 * @prop {number} Product2
 * @prop {string} Product2Symbol
 * @prop {number} PriceIncrement
 * @prop {number} QuantityIncrement
 */

function useCalculatorPnLValue(formName) {
  var dispatch = (0, _reactRedux.useDispatch)();

  /** @type {FormValues} */
  var formValues = (0, _hooks.useFormValues)(formName);
  var leverage = formValues.leverage,
    entryPrice = formValues.entryPrice;

  /** @type {Instrument | undefined} */
  var selectedInstrument = (0, _reactRedux.useSelector)(_futuresInstrumentsSelector.futuresSelectedInstrumentSelector);
  var valueDP = selectedInstrument ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement) : 2;
  var quantityDP = selectedInstrument ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement) : 2;
  var contractCurrency = selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.Product1Symbol;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    maxPosition = _useState2[0],
    setMaxPosition = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    maxAmount = _useState4[0],
    setMaxAmount = _useState4[1];
  (0, _react.useEffect)(function () {
    if (leverage) {
      dispatch((0, _actions.getFuturesMaxPosition)(leverage)).then(function (result) {
        setMaxPosition(result ? {
          value: result.MaxPositionAmount,
          symbol: result.MaxPositionAmountProductSymbol
        } : null);
      });
    } else {
      setMaxPosition(null);
      setMaxAmount(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leverage]);
  (0, _react.useEffect)(function () {
    if (maxPosition !== null && maxPosition !== void 0 && maxPosition.value && entryPrice && leverage) {
      dispatch((0, _actions.getFuturesEstimatedMaxAmount)({
        MaxPositionAmount: maxPosition.value,
        EntryPrice: entryPrice,
        LeverageMultiplier: leverage
      })).then(function (result) {
        setMaxAmount(result ? {
          value: result.MaxAmount,
          symbol: result.MaxAmountProductSymbol
        } : null);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxPosition === null || maxPosition === void 0 ? void 0 : maxPosition.value, entryPrice, leverage]);

  /**
   * 3.4.g.1 Long Linear Stablecoin-Settled Futures Contracts and Linear Coin-Margined Futures Contracts:
   * (Exit Price - Entry Price) * Quantity. Profit/Loss is represented in the settlement currency (P2).
    3.4.g.2 Short Linear Stablecoin-Settled Futures Contracts and Linear Coin-Margined Futures Contracts:
   (Entry Price - Exit Price) * Quantity. Profit/Loss is represented in the settlement currency (P2).
   */
  var PnLCurrency = selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.Product2Symbol;
  var PnLValue = (0, _react.useMemo)(function () {
    if (!formValues || !selectedInstrument) return 0;
    var type = formValues.type,
      entryPrice = formValues.entryPrice,
      exitPrice = formValues.exitPrice,
      quantity = formValues.quantity;

    // Skip calculation if any required value is missing or zero
    if (!entryPrice || !exitPrice || !quantity) return 0;
    var pnl = 0;
    if (type === 'Long') {
      pnl = (exitPrice - entryPrice) * quantity;
    } else {
      pnl = (entryPrice - exitPrice) * quantity;
    }
    return pnl;
  }, [formValues, selectedInstrument]);
  return {
    selectedInstrument: selectedInstrument,
    valueDP: valueDP,
    quantityDP: quantityDP,
    contractCurrency: contractCurrency,
    PnLValue: PnLValue,
    PnLCurrency: PnLCurrency,
    maxPosition: maxPosition,
    maxAmount: maxAmount
  };
}